import React, { Fragment, useState, useRef } from "react";
import ReactToPrint from "react-to-print";
import uiUtils from "../UI/uiUtils";
import Divider from "../UI/Divider";
import simpleUtils from "../simpleUtils";
import Addendum from "./Addendum";
import FieldArraySummary from "./FieldArraySummary";
import { FaPrint } from "react-icons/fa";
import Parser from "html-react-parser";
import "./style.scss";
import { formTextResolver, renderHeader } from "./FormSummaryText";
import { formUiSchemaResolver, formCleanersValues } from "./cleaner";
import contentInsertion from "./contentInsertion";
import { useSelector } from "react-redux";

const AppendicesResolver = {
  formUI9089: [
    "Appendix A.B - Foreign Worker Education",
    "Appendix A.C - Foreign Worker Training Qualifications",
    "Appendix A.D - Foreign Worker Skills",
    "Appendix A.E - Foreign Worker Work Experience",
  ],
};

const hideTheseFields = {
  formUI9089: {
    // Key is page index, values are list of codes
    6: {
      "a.2": "N/A",
      "a.3": "N/A",
      "a.4": "N/A",
      "a.5": 0,
      "a.6": "N/A",
      "a.7": "N/A",
      "a.8": 0,
      "a.8.a": "N/A",
    },
  },
};

const FormSummary = (props) => {
  let { values, uiSchema_nav, uiSchema_lookup, formName } = props;
  let { all_values } = props;
  const formVersionId = values.formVersionId;
  const [selectedValue, selectOption] = useState("- Select -");
  const [expandAll, setExpandAll] = useState(undefined);
  const { formExpirationDates } = useSelector(
    (state) => state.referenceReducer
  );
  const selectConditional = (page_name) => {
    return {
      display:
        selectedValue === page_name || selectedValue === "- Select -"
          ? "block"
          : "none",
    };
  };
  // if all_values doesn't exist then create it
  if (!all_values) {
    // parseMachineNameForObjectBuilding -- lets you format the datastructure FormSummary will use
    let parsed_values = simpleUtils.parseMachineNameForObjectBuilding(
      values,
      uiSchema_nav,
      uiSchema_lookup
    );
    let _all_values = parsed_values.filter(
      (obj) => obj.page_title !== "Application Documents"
    );
    _all_values = _all_values.filter(
      (obj) =>
        !(
          obj.label &&
          obj.label.startsWith("Uploaded") &&
          obj.value &&
          obj.value === "NO"
        ) || !(obj.reviewHidden && obj.reviewHidden === true)
    );
    if (formName === "formUI9089") {
      _all_values = _all_values.filter((obj) => obj.reviewHidden !== true);
    }
    // lets you change which fields belong to which section/page
    all_values = formCleanersValues(formName, _all_values, formVersionId);
  }
  let _cleaned_ui_schema = uiSchema_nav.filter(
    (obj) => obj.name !== "Application Documents"
  );

  // formUiSchemaResolver gives you chance to use a different section layout for overview page instead of using default uiSchema_nav
  let cleaned_ui_schema = formUiSchemaResolver(
    formName,
    _cleaned_ui_schema,
    formVersionId
  );
  const summaryRef = useRef();
  // provides form expiration dates, footer notes, official form name/id, etc.
  const formTextKey =
    formVersionId === 2 && formName === "formUI790A"
      ? `${formName}V2`
      : formName;
  const formExpirationDate = formExpirationDates[formTextKey];
  const form = formTextResolver(formTextKey, formExpirationDate);

  return (
    <Fragment>
      <div ref={summaryRef}>
        <div className="selector-container">
          <div class="usa-form">
            <label class="usa-label" htmlFor="summary-select">
              Select what form/section you would like to view:
            </label>
            <select
              class="usa-select"
              name="summary-select"
              id="summary-select"
              onChange={(e) => selectOption(e.target.value)}
            >
              <option key={-1} value="- Select -">
                - Select -
              </option>
              {cleaned_ui_schema.map((item, index) => {
                let page_name = item.name && uiUtils.removeLineBreak(item.name);
                return (
                  <option key={page_name} value={page_name}>
                    {page_name}
                  </option>
                );
              })}
            </select>
          </div>
        </div>
        {form &&
          renderHeader(
            form,
            <ReactToPrint
              trigger={() => (
                <span className="print-link">
                  <span className="underline">Print Summary</span>{" "}
                  <FaPrint size={"0.75rem"} />
                </span>
              )}
              onBeforePrint={() => setExpandAll(true)}
              onAfterPrint={() => setExpandAll(undefined)}
              // content to print is a dom ref of the summary page
              content={() => summaryRef.current}
              bodyClass="review-and-sumbit-page-print"
              // copyStyles={false}
            />
          )}

        <div>
          {/* loop through nice overview layout */}
          {cleaned_ui_schema.map((navItem, index) => {
            // loop through every value oof and use the index to get items by page_index
            let value_for_page = all_values.filter(
              (e) => parseInt(e.page_index) === index
            );
            let values_for_page = value_for_page.map((item, index) => {
              if (item["code"]) {
                let splitCode = item["code"] && item["code"].split(".");
                if (
                  splitCode &&
                  splitCode[1] &&
                  splitCode[0].indexOf("Addendum") === -1
                ) {
                  // regular code key
                  splitCode.shift();
                  item["code"] = splitCode.join(".");
                } else {
                  // addendum code key
                  item["code"] = splitCode[0] + ".";
                }
              }
              return item;
            });
            // order fields for the section/page
            let tab_values = values_for_page.sort((a, b) => {
              a["tempCode"] = a.code;
              b["tempCode"] = b.code;
              if (!a.hasOwnProperty("code")) {
                let aKeys = Object.keys(a);
                a["tempCode"] = aKeys[1].slice(2);
              }
              if (!b.hasOwnProperty("code")) {
                let bKeys = Object.keys(b);
                b["tempCode"] = bKeys[1].slice(2);
              }
              if (a["tempCode"] && b["tempCode"]) {
                return a["tempCode"].localeCompare(b["tempCode"], "en", {
                  numeric: true,
                  ignorePunctuation: true,
                });
              }
            });
            tab_values = tab_values.map((item) => {
              delete item.tempCode;
              return item;
            });
            let prefix =
              navItem.prefix && uiUtils.removeLineBreak(navItem.prefix);
            let page_name =
              navItem.name && uiUtils.removeLineBreak(navItem.name);
            return (
              <div key={`section-${index}`} className="review-and-sumbit-page">
                {values.length !== 0 && (
                  <div className="form-summary-container">
                    <div
                      className="summary-section-names tab"
                      href="summary-section-names"
                      style={selectConditional(page_name)}
                    >
                      <input
                        type="checkbox"
                        id={page_name}
                        checked={expandAll}
                      />
                      <label className="tab-label" htmlFor={page_name}>
                        <span>
                          {prefix && <span>{`${prefix}: `}</span>}
                          {page_name && <span>{`${page_name}`}</span>}
                        </span>
                      </label>
                      {navItem && navItem.note && (
                        <div className="tab-content">
                          {navItem.note && (
                            <small>{Parser(navItem.note)}</small>
                          )}
                        </div>
                      )}
                      {tab_values.map((o, i) => {
                        let isList = Object.keys(o).length < 4;

                        let value = o.value;
                        value =
                          o.label &&
                          o.label.includes("County") &&
                          value &&
                          value.label
                            ? value.label
                            : value;

                        // isList when you want to display values as a bulleted list
                        if (isList) {
                          let listObj, code;
                          let field = o[Object.keys(o)[2]];
                          listObj = o[Object.keys(o)[1]];
                          code = Object.keys(o)[1]
                            ? Object.keys(o)[1].slice(2) + " "
                            : "";
                          field = `${code}${field}`;
                          let listOfValues = Object.keys(listObj).map(
                            (index) => {
                              o = listObj[index];
                              let useLabel = Array.isArray(o.value);
                              value = useLabel ? o.label : o.value;
                              return (
                                <Fragment>
                                  {value ? (
                                    <div
                                      key={`${
                                        typeof value !== "object"
                                          ? value
                                          : "N/A"
                                      }-${i}`}
                                      className="is-list-li"
                                    >
                                      <span className="summary-answers">
                                        {`${
                                          typeof value !== "object"
                                            ? value
                                            : "N/A"
                                        }`}
                                      </span>
                                    </div>
                                  ) : null}
                                </Fragment>
                              );
                            }
                          );
                          if (
                            o.page_index === 12 &&
                            formName === "formUI9089"
                          ) {
                            field = " ";
                            if (o.label == "<b>H.e.1f</b>") {
                              value = o.value
                                ? "The employer DID NOT post the notice of filing."
                                : null;
                              listOfValues = [
                                <Fragment>
                                  {value ? (
                                    <div
                                      key={`${
                                        typeof value !== "object"
                                          ? value
                                          : "N/A"
                                      }-${i}`}
                                      className="is-list-li"
                                    >
                                      <span className="summary-answers">
                                        {`${
                                          typeof value !== "object"
                                            ? value
                                            : "N/A"
                                        }`}
                                      </span>
                                    </div>
                                  ) : null}
                                </Fragment>,
                              ];
                            }
                          }
                          if (listObj === 13 && formName === "formUI9089") {
                            field = " ";
                            value = !!o[1][0].value
                              ? `I certify under penalty of perjury my knowledge of and 
                              compliance with the applicable Labor Condition Statements 
                              above covering the conditions of employment for the job 
                              opportunity and foreign worker covered by this application. 20 CFR 656.10(c).`
                              : null;
                            listOfValues = [
                              <Fragment>
                                {value ? (
                                  <div
                                    key={`${
                                      typeof value !== "object" ? value : "N/A"
                                    }-${i}`}
                                    className="is-list-li"
                                  >
                                    <span className="summary-answers">
                                      {`${
                                        typeof value !== "object"
                                          ? value
                                          : "N/A"
                                      }`}
                                    </span>
                                  </div>
                                ) : null}
                              </Fragment>,
                            ];
                          }
                          return (
                            <div
                              style={selectConditional(page_name)}
                              className="tab-content"
                            >
                              <div className="field-item">
                                <div
                                  key={`field-list-${i}`}
                                  className="grid-row"
                                >
                                  <span>
                                    {Parser(
                                      `${field}${
                                        field.includes(":") || field === " "
                                          ? ""
                                          : ":"
                                      } `
                                    )}
                                  </span>
                                  <ul className="is-list-ul">{listOfValues}</ul>
                                </div>
                              </div>
                              <Divider />
                            </div>
                          );
                        } else {
                          // most fields are not shown as unordered list and go through here
                          // towards the end -- if value is an object probably an addendum or array of values/fieldArray
                          let fieldClass =
                            typeof value === "object"
                              ? "field-item addendum-item"
                              : "field-item";
                          if (
                            o &&
                            o.label &&
                            (o.label.includes("Document Upload") ||
                              o.label.startsWith("Uploaded"))
                          ) {
                            o.code = "";
                          }
                          const isDate =
                            typeof value == "string" &&
                            value.match(
                              /^(-?(?:[1-9][0-9]*)?[0-9]{4})-(1[0-2]|0[1-9])-(3[01]|0[1-9]|[12][0-9])T(2[0-3]|[01][0-9]):([0-5][0-9]):([0-5][0-9])(.[0-9]+)?(Z)?$/
                            );
                          if (
                            hideTheseFields[formName]?.[o.page_index]?.[
                              o.code
                            ] === (o.value?.value ?? o.value) ||
                            o.reviewHidden === true
                          ) {
                            return null;
                          }
                          return (
                            <div
                              key={`non-list-answers${i}`}
                              style={selectConditional(page_name)}
                              className="tab-content"
                            >
                              {contentInsertion(o.page_title, o.code)()}
                              <div className={fieldClass}>
                                <div
                                  key={`field-not-list-${i}`}
                                  className="grid-row"
                                >
                                  {o &&
                                    o.label &&
                                    o.label !== "no title" &&
                                    o.code !== "undefined." && (
                                      <span className="grid-col-6 summary-label">
                                        {typeof o.label === "string" &&
                                          (o.label !== "no label"
                                            ? Parser(
                                                `${o.code ? o.code : ""} ${
                                                  o.label
                                                }`
                                              )
                                            : "Field: " + o.code)}
                                      </span>
                                    )}

                                  <span className="grid-col-6 summary-answers">
                                    {`${
                                      typeof value !== "object" && !isDate
                                        ? value
                                        : typeof value[0] === "string" &&
                                          !isDate
                                        ? value[0]
                                        : ""
                                    }`}
                                    {`${
                                      value instanceof Date
                                        ? value.getMonth() +
                                          1 +
                                          "/" +
                                          value.getDate() +
                                          "/" +
                                          value.getFullYear()
                                        : ""
                                    }`}
                                    {value && value.length > 10 && isDate
                                      ? `${
                                          new Date(value).getMonth() + 1
                                        }/${new Date(
                                          value
                                        ).getDate()}/${new Date(
                                          value
                                        ).getFullYear()}`
                                      : ""}
                                  </span>
                                </div>
                                <Divider />
                                {typeof value === "object" &&
                                  Object.prototype.toString.call(value) !==
                                    "[object Date]" &&
                                  o &&
                                  o.code &&
                                  (o.code.indexOf("Addendum") > -1 ||
                                    o.code.indexOf("Appendix") > -1 ||
                                    AppendicesResolver[formName]?.includes(
                                      o.page_title
                                    )) && (
                                    <Addendum
                                      obj={o}
                                      state={selectedValue}
                                      formName={formName}
                                      allValues={values}
                                    />
                                  )}
                                {typeof value === "object" &&
                                  Object.prototype.toString.call(value) !==
                                    "[object Date]" &&
                                  o &&
                                  o.code &&
                                  o.code.indexOf("Addendum") === -1 &&
                                  o.code.indexOf("Appendix") === -1 &&
                                  !AppendicesResolver[formName]?.includes(
                                    o.page_title
                                  ) && (
                                    <FieldArraySummary
                                      obj={o}
                                      formName={formName}
                                    />
                                  )}
                              </div>
                            </div>
                          );
                        }
                      })}
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </Fragment>
  );
};

export default FormSummary;
